import { useNavigate } from "react-router";
import { useAccount } from "@/context/account";
import { useTrackedDialogs } from "@/context/dialogs";
import AddDeviceModal from "./AddDeviceModal";
import { useViewDeviceNavigation } from "./useViewDeviceNavigation";

export function useAddDeviceDialog() {
  const dialogs = useTrackedDialogs();
  const navigate = useNavigate();
  const { accountRouteId } = useAccount();
  const getViewDeviceNavigation = useViewDeviceNavigation();

  return {
    open: async (onRequested?: () => void) => {
      const serialNumber = await dialogs.open(AddDeviceModal);
      if (serialNumber == null) {
        return;
      }
      onRequested?.();
      const { search, state } = getViewDeviceNavigation(serialNumber);
      navigate({ pathname: `/${accountRouteId}/devices`, search }, { state });
    },
  };
}
